import React, {Component} from 'react';
import {compose, withProps} from 'recompose';
import {withScriptjs, withGoogleMap, GoogleMap} from 'react-google-maps';
import cx from 'classnames';
import i18next from 'i18next';

import Checkbox from '~components/Checkbox';

import {Project} from '../../types';
import ProjectMarker from '../ProjectMarker';

import styles from './styles.module.scss';
import mapStyles from './map-styles';
import {GOOGLE_MAPS_API_KEY, DEFAULT_ZOOM, CONTROL_SIZE, NAME_CHECKBOX} from './constants';
import {getDistance} from './utils';
import {Route} from "~services/RoutesService";
import {ElementHelper} from "~screens/Dashboard/screens/ProjectsIIRSA/screens/ElementsMap/components/MapList";

interface Props {
    projects: Project[] | Route[];
    route?: Route;
    loading?: boolean;
    hoveredProjectId?: number;
    selectedProjectId?: number;
    isSingle?: boolean;
    zoom?: number;
    handleChangeCheckbox: () => void;
    selectable?: boolean;
}

class Map extends Component<Props> {
    mapRef = {getBounds: () => ({})};

    renderProjectMarker = (project: Project | Route) => {
        const {hoveredProjectId, selectedProjectId, selectable} = this.props;
        const id = ElementHelper.getElementId(project);

        return (
            <ProjectMarker
                key={project.id}
                project={project}
                hovered={hoveredProjectId === project.id}
                selected={selectedProjectId === project.id}
                selectable={selectable || false}
                visible={hoveredProjectId === null || hoveredProjectId === undefined || hoveredProjectId === id}
            />
        );

    };

    renderRouteMarker = (route: Route) => {
        return (
            <ProjectMarker
                key={route.id}
                project={route}
                hovered={true}
                selected={false}
                visible={true}
                activeSettings={{
                    fillOpacity: 0.05,
                    strokeWeight: 0.75,
                    fillColor: '#000000',
                    strokeColor: '#000000',
                }}
                inactiveSettings={{
                    fillOpacity: 0.05,
                        strokeWeight: 0.75,
                        fillColor: '#000000',
                        strokeColor: '#000000',
                }}
            />
        );
    }

    setMapRef = map => (this.mapRef = map);

    render() {
        const {projects, route,  loading,  zoom, handleChangeCheckbox} = this.props;
        let defaultCenter = {lat: -26, lng: -66};
        let useZoom = zoom || DEFAULT_ZOOM;
        const projectOrRoute = projects?.[0];
        const isSingle = projects?.length === 1;
        if (projectOrRoute?.hasOwnProperty('dynamicCenter')) {
            const project = projectOrRoute as Project;
            const dynamicCenter = project?.dynamicCenter;
            if (isSingle && dynamicCenter) {
                const lat = Number.parseFloat(dynamicCenter.latitude.toString());
                const lng = Number.parseFloat(dynamicCenter.longitude.toString());
                defaultCenter = {lat, lng};
            }
        }
        if (route && route.ajusteMapa) {
            const lat = Number.parseFloat(route.ajusteMapa.latitude.toString());
            const lng = Number.parseFloat(route.ajusteMapa.longitude.toString());
            defaultCenter = {lat, lng};
            useZoom = route.ajusteMapa.zoom;
        }

        return (
            <GoogleMap
                ref={this.setMapRef}
                defaultZoom={useZoom}
                defaultCenter={defaultCenter}
                zoom={useZoom}
                center={defaultCenter}
                defaultOptions={{
                    styles: mapStyles,
                    streetViewControl: false,
                    scaleControl: false,
                    mapTypeControl: false,
                    panControl: false,
                    rotateControl: false,
                    fullscreenControl: false,
                    controlSize: CONTROL_SIZE
                }}
            >
                {!loading && !isSingle && projects?.map(this.renderProjectMarker)}
                {!loading && route && this.renderRouteMarker(route)}
                {isSingle && <ProjectMarker project={projects[0] as Project} hovered visible/>}
            </GoogleMap>
        );
    }
}

export default compose(
    withProps(ownerProps => ({
        googleMapURL: `https://maps.googleapis.com/maps/api/js?v=3.exp&key=${GOOGLE_MAPS_API_KEY}&libraries=geometry,drawing,places`,
        loadingElement: <div className={styles.loading}/>,
        containerElement: (
            <></>
        ),
        mapElement: <div className={styles.map}/>
    })),
    withScriptjs,
    withGoogleMap
)(Map);
